import React from 'react'
import { useTranslation } from 'react-i18next'
import css from './Booking.module.css'
import classNames from 'classnames'
const BookingStatusCodeInfo = () => {
  const { t } = useTranslation()
  return (
    <div className={classNames(css['info-group'])}>
      <div><span className={classNames(css['OK'])}></span> {t('status_no_color_confirmed')}</div>
      <div><span className={classNames(css['PS_OK'])}></span> {t('status_green_all_confirmed')}</div>
      <div><span className={classNames(css['PS_RQ'])}></span> {t('status_grey_pending')}</div>
      <div><span className={classNames(css['WAIT'])}></span> {t('status_red_wait')}</div>
      <div><span className={classNames(css['NSC'])}></span> {t('status_yellow_no_show_cancelled')}</div>
    </div>
  );
};
export default BookingStatusCodeInfo
